import { getContext } from 'svelte';
import { get } from '../data';
export const CONTEXT_CONTEXT = 'content';
export function useContent() {
    return getContext(CONTEXT_CONTEXT);
}
const INFOBOX_CACHE = {};
export function createContentContext(endpoint) {
    return {
        builderTiles: async () => {
            try {
                const result = await get(endpoint('builder-tiles'));
                // Preload images so they're there instantly when the accordions open:
                result.map((tileContent) => {
                    const image = new Image();
                    image.src = tileContent.image;
                });
                return result;
            }
            catch {
                return null;
            }
        },
        infobox: async (title) => {
            const cached = INFOBOX_CACHE[title];
            if (cached) {
                return cached;
            }
            try {
                const result = get(endpoint('infobox', new URLSearchParams({ title })));
                INFOBOX_CACHE[title] = result;
                return await result;
            }
            catch {
                INFOBOX_CACHE[title] = Promise.resolve(null);
                return null;
            }
        }
    };
}
